// extracted by mini-css-extract-plugin
export default {"textContainer":"IndexCardTitle_textContainer__shJFF","number":"IndexCardTitle_number__-2mXO"};